<template>
  <v-toolbar dense>
    <v-toolbar-title>Title</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn icon>
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
    <v-btn icon>
      <v-icon>mdi-heart</v-icon>
    </v-btn>
  </v-toolbar>
</template>

<script>
export default {
  name: "ToolbarItem",
};
</script>

<style>
#toolbar-title {
  font-weight: bold;
  font-size: 30px;
}
</style>
